import React from "react";
import { ModalCrosSvg } from "../../../images/Svgs";
import { formatAMPM, formatDate } from "../../../utils/common";
const UserDetail = ({ onUserModalClose, UserData }) => {
  return (
    <div className="modal fade show">
      <div className="modal-dialog add_new_event_box">
        <div className="modal-content">
          <div className="modal-header">
            <h1
              className="modal-title fs-5 font-18 text-capitalize"
              id="exampleModalLabel"
            >
              {UserData?.first_name} {UserData?.last_name}
            </h1>
            <button
              type="button"
              className="new_event_lose inter"
              onClick={() => onUserModalClose(false)}
            >
              <ModalCrosSvg />
            </button>
          </div>
          <div class="modal-body">
            <div class="col-md-12 col-12">
              <div class="day_time">
                <div class="entry_title">
                  <p>Email :</p>
                </div>
                <div class="popup-header-text">
                  <div class="small_group">
                    <p>{UserData?.email}</p>
                  </div>
                </div>
                <div class="row gx-5"></div>
              </div>
              <div class="col-md-12 col-12">
                <div class="day_time">
                  <div class="entry_title">
                    <p>Status :</p>
                  </div>
                  <div class="small_group">
                    <p>
                      {UserData?.is_active === true ? "Active" : "Deactive"}
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-12">
                <div class="day_time">
                  <div class="entry_title">
                    <p>Access :</p>
                  </div>
                  <div class="small_group">
                    <p>{UserData?.is_access === true ? "Yes" : "No"}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserDetail;
